var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_vm._v(" this is 毕业离校 ")])}
var staticRenderFns = []

export { render, staticRenderFns }